export const GET_USER_KEYS_REQUEST = 'GET_USER_KEYS_REQUEST'
export const GET_USER_KEYS_SUCCESS = 'GET_USER_KEYS_SUCCESS'
export const GET_USER_KEYS_FAILURE = 'GET_USER_KEYS_FAILURE'
export const CREATE_KEY_REQUEST = 'CREATE_KEY_REQUEST'
export const CREATE_KEY_SUCCESS = 'CREATE_KEY_SUCCESS'
export const CREATE_KEY_FAILURE = 'CREATE_KEY_FAILURE'
export const READ_KEY_REQUEST = 'READ_KEY_REQUEST'
export const READ_KEY_SUCCESS = 'READ_KEY_SUCCESS'
export const READ_KEY_FAILURE = 'READ_KEY_FAILURE'
export const UPDATE_KEY_REQUEST = 'UPDATE_KEY_REQUEST'
export const UPDATE_KEY_SUCCESS = 'UPDATE_KEY_SUCCESS'
export const UPDATE_KEY_FAILURE = 'UPDATE_KEY_FAILURE'
export const DELETE_KEY_REQUEST = 'DELETE_KEY_REQUEST'
export const DELETE_KEY_SUCCESS = 'DELETE_KEY_SUCCESS'
export const DELETE_KEY_FAILURE = 'DELETE_KEY_FAILURE'
